
<article class="bg-white border-gray-200 mt-6 px-4 lg:px-6 py-2.5">
    <div class="justify-between items-center mx-auto max-w-screen-xl">
        <h1 id="nav-projekt" class="">Das Projekt</h1>

        <p class="mx-32 mt-5 text-justify">
            Bei einem Online-Labor, oft auch Remote-Labor genannt, handelt es sich um eine real existierende Hardware-Infrastruktur,
            die zeit- und ortsunabhängig über das Internet ferngesteuert wird. In Forschung und Bildung können so Naturwissenschaft
            und Technik praxisnah vermittelt werden. Online-Labore bieten die Möglichkeit, klassische Laborübungen und Demonstrationen
            im Präsenzunterricht zu ergänzen oder ganz zu ersetzen. Auch in Abendschulen und -kursen können Online-Labore dazu dienen,
            trotz limitieren Zeitbudgets, wertvolle praktische Erfahrungen zu sammeln.
        </p>
        <p class="mx-32 mt-5 text-justify">
            Das Projekt „Online-Labore für naturwissenschaftliche Aus- und Weiterbildung“ - kurz OnLabEdu - hat sich die Entwicklung
            und Untersuchung von Online-Laboren für die naturwissenschaftliche Aus-und Weiterbildung an Österreichs Schulen als Ziel gesetzt.
            Durch didaktische Aufbereitung jener Labore wird versucht, in den ausgewählten Gebiete benutzerfreundliches und lerneffizientes Arbeiten
            zu gewährleisten. In Zeiten steigenden Bedarfs an Distance Learning-Angeboten kann auf diese Weise ein Praxisbezug zur Theorie hergestellt
            und der Unterricht bereichert werden. Durch die wissenschaftlich-didaktische Begleitung der Pädagogischen Hochschule Steiermark wird sichergestellt,
            dass die Lernumgebungen der Online-Labore didaktisch fundiert und strukturiert an die Lernendenperspektiven der Zielgruppen angepasst werden.
        </p>
        <p class="mx-32 mt-5 text-justify">
            Mit der Umsetzung und Verbreitung dieses Projekts soll ein Raum für weitere Innovationsideen im Bildungsbereich geschaffen werden,
            welche in didaktischem Lernmaterial oder neuen Laborideen resultieren kann. Lehrende und Bildungsfachleute aus ganz Österreich
            sind herzlich dazu eingeladen mit unseren Online-Laboren neue Bildungsformate zu testen, neue Lehrmethoden zu evaluieren
            oder neue Unterrichtsmaterialien zu erabeiten.
        </p>

    </div>
</article>
